<div class="flex-center py-6">
  <div class="narrow-card-container">
    <div class="card">
      <div class="card-body p-4 p-sm-5">
        <div class="row flex-between-center mb-3">
          <div class="col-auto">
            <h5>
              {{ "twoFactorAuthEnable.twoFactorAuthentication" | translate }}
            </h5>
          </div>
          <app-info-label [label]="'twoFactorAuthEnable.twoFAInfo'" />
        </div>
        <hr />
        <form [formGroup]="formGroup" (submit)="onSubmit()">
          <div class="mt-4">
            <label class="sub-section-text">{{
              "twoFactorAuthEnable.readQRCode" | translate
            }}</label>
          </div>
          <div>
            <span>{{
              "twoFactorAuthEnable.readQRCodeWithApp" | translate
            }}</span>
          </div>
          <div class="qr-code my-3 mb-4">
            <img width="350px" src="{{ qrCode }}" />
          </div>
          <div>
            <span for="">{{
              "twoFactorAuthEnable.orPasteCode" | translate
            }}</span>
          </div>
          <label>{{ code }}</label>
          <div class="mb-4">
            <a class="fs-10" (click)="copyCode()">{{
              "twoFactorAuthEnable.copyCode" | translate
            }}</a>
          </div>
          <hr />
          <div class="mb-4">
            <div class="mt-4">
              <span class="sub-section-text">{{
                "twoFactorAuthEnable.reinforceCode" | translate
              }}</span>
              <div>
                <span class="form-label">{{
                  "twoFactorAuthEnable.copyCodeToInput" | translate
                }}</span>
              </div>
              <app-validated-input
                label="twoFactorAuthEnable.authCode"
                inputFormControlName="code"
                [inputFormControl]="formGroup.controls.code"
                [validationTrainslations]="{ required: 'validation.required' }"
              />
            </div>
          </div>
          <hr />
          <!--div class="row flex-between-center">
            <div class="col-auto">
              <div class="form-check mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="card-checkbox"
                  checked="checked"
                /><label class="form-check-label mb-0" for="card-checkbox">{{
                  "twoFactorAuthEnable.trustedDevice" | translate
                }}</label>
              </div>
            </div>
          </div-->
          <div class="mb-3">
            <button
              class="btn btn-primary d-block w-100 mt-3"
              type="submit"
              name="submit"
            >
              {{ "twoFactorAuthEnable.activate" | translate }}
            </button>
          </div>
          <div>
            <button
              class="btn btn-falcon-default w-100"
              type="submit"
              name="submit"
            >
              {{ "general.cancel" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
